import { Landing } from '@anm/api/modules/hosting';
import { ListItem } from '@anm/components/list/SelectionList';
import { DEFAULT_THEME } from '@anm/constants/videoLandings';
import {
  layoutSelection,
  themeSelection
} from '@anm/data/video-landings/selection';

type ItemType = 'theme' | 'layout';

// const FIRST_INDEX = 0;

const findSelectedIndex = (itemType: ItemType, itemName: string) => {
  const arrayToFind = itemType === 'theme' ? themeSelection : layoutSelection;
  const index = arrayToFind.findIndex(
    (item: ListItem) => item.name === itemName
  );

  return index;
};

export const getSelectedItemIndex = (itemType: ItemType, landing: Landing) => {
  const currentTemplate = landing.template;
  const currentTheme = landing.parameters?.theme || DEFAULT_THEME;

  switch (itemType) {
    case 'layout':
      return findSelectedIndex(itemType, currentTemplate);

    case 'theme':
      return findSelectedIndex(itemType, currentTheme);

    // default:
    //   return FIRST_INDEX;
  }
};
